<script type="text/javascript" src="http:///api?v=2.0&ak=dkjdz7G1QTrtyH1BfyK3neuIExaAtWQW"></script>
<template>
  <div class="lianxi" style="padding-top: 50px;">
    <img src="../../static/image/lianxiwomen_title.png" class="fullWidth" />
    <div style="height: 100px;"></div>
    <Row type="flex" justify="center" class="code-row-bg">
      <div style="width:460px;height: 500px;background: #999999">
        <div style="height: 50px;"></div>
        <div class="fontfaYahei font36 colorW alignCenter">联系方式</div>
        <div style="height:60px;"></div>
        <div class="fontfaYahei font14 colorW centerLR tel">电 话： {{basic_information.phone}}</div>
        <div style="height:31px;"></div>
        <div class="fontfaYahei font14 colorW centerLR tel">邮 箱： {{basic_information.email}}</div>
        <div style="height:31px;"></div>
        <div class="fontfaYahei font14 colorW centerLR tel">Q Q： {{basic_information.qq}}</div>
        <div style="height:31px;"></div>
        <div class="fontfaYahei font14 colorW centerLR tel">地 址： {{basic_information.address}}</div>
      </div>

      <Col span="10">
        <div style="width: 80%;height: 500px;" class="centerLR">
          <div style="height: 30px;"></div>
          <div class="fontfaYahei font36 color66">留言板</div>
          <div style="height: 50px;"></div>
          <Input v-model="name" placeholder="您的姓名" />
          <div style="height: 30px;"></div>
          <Input v-model="phone" placeholder="您的电话" />
          <div style="height: 30px;"></div>
          <Input v-model="xuqiu" type="textarea" :rows="6" placeholder="您的需求" />
          <div style="height: 50px;"></div>
          <Button type="warning" @click="submitData">提交留言</Button>
        </div>
      </Col>
    </Row>
    <div style="height: 100px;"></div>
    <div class="alignCenter fontfaYahei font36 color33">
      <img src="../../static/image/gzwm1.png" alt />
    </div>
    <div style="height: 50px;"></div>

    <Row type="flex" justify="center" class="code-row-bg">
      <Col span="14">
        <Row>
          <Col span="8" v-for="(item,index) in guanzhuList" :key="index">
            <div>
              <img class="centerLR" :src="item.pic_url" style="width: 188px;" />
            </div>
            <div style="background: #FD7B35;width: 188px;height: 50px;line-height: 50px;" class="centerLR alignCenter fontfaYahei font20 colorW">{{item.pic_name}}</div>
          </Col>
        </Row>
      </Col>
    </Row>
    <div style="height: 100px;"></div>
    <div class="alignCenter fontfaYahei font36 color33">
      <img src="../../static/image/wmzz.png" alt />
    </div>
    <div style="height: 50px;"></div>
    <baidu-map
      class="map"
      :style="{height:mapHeight}"
      style="width: 100%;"
      :center="{lng:113.7840615555,lat:34.7544770957}"
      :zoom="17"
      :scroll-wheel-zoom="true"
    >
      <bm-marker
        :position="{'lng': 113.7840615555, 'lat': 34.7544770957}"
        :dragging="true"
        animation="BMAP_ANIMATION_BOUNCE"
      >
        <bm-label
          content="简云科技"
          :labelStyle="{'color': 'red', 'fontSize' : '24px'}"
          :offset="{'width': -35, 'height': 30}"
        />
      </bm-marker>
    </baidu-map>
    <div style="height: 100px;"></div>
    <xfck @func="getMsgFormSon"></xfck>
  </div>
</template>
<script>
import $ from "jquery";
import xfck from "./xfck.vue";

var img_url_i = "";
// if (window.location.host.slice(0, 5) === "local") {
//   img_url_i = "..";
// } else {
//   img_url_i = "/jianyunPC";
// }

export default {
  name: "lianxi",
  data() {
    return {
      name: "",
      phone: "",
      xuqiu: "",
      mapHeight: ($(window).width() * 700) / 1919 + "px",
      basic_information: "",
      guanzhuList: []
    };
  },
  created() {
        this.get_basic_information();
  },
  methods: {
    get_basic_information() {
      var that = this;
      var url =
        that.baseUrl + "/jianyun/api/mall.php?c=about_us/getCompanyInfo";
      that.axios
        .get(url, {
          params: {
            type: 3
          }
        })
        .then(res => {
          if (res.data.success) {
            that.basic_information = res.data.data;
          } else {
            this.$Message.warning(res.data.msg);
          }
        })
        .catch(error => {
          // console.log(error);
        });
    },
    getMsgFormSon(data){
       console.log(data)
       this.guanzhuList = data;
    },
    submitData() {
      var that = this;
      var url = that.baseUrl + "/jianyunadmin/api.php?c=contact_us";
      this.$Message.config({
        top: 100,
        duration: 3
      });
      if (that.name === "") {
        return this.$Message.warning(
          "请留下您的姓名，我们将会有专业客服联系您~！"
        );
      }
      if (that.phone === "") {
        return this.$Message.warning(
          "请留下您的联系方式，我们将会有专业客服联系您~！"
        );
      }
      if (that.xuqiu === "") {
        return this.$Message.warning(
          "请留下您的需求，我们将会有专业客服跟您确认~！"
        );
      }
      that.axios
        .get(url, {
          params: {
            cooperation_contacts: that.name,
            cooperation_phone: that.phone,
            cooperation_content: that.xuqiu
          }
        })
        .then(res => {
          // console.log(res);
          if (res.data.success) {
            this.$Message.success("提交成功~！");
          } else {
            this.$Message.warning(res.data.msg);
          }
        })
        .catch(error => {
          // console.log(error);
        });
    }
  },
  mounted(){

  },
  components: {
    xfck
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tel {
  width: 300px;
  /* margin-left: 75px; */
}
</style>



// WEBPACK FOOTER //
// src/components/lianxi.vue